<template lang="html">
   <div class="page-container">
        <div class="page-container__header"> 
                <h1 class="header-1 page-container__title">Specialisti</h1>
            </div>
            <div class="page-container__body">
                <div class="category-list" v-arrowscroll>
                    <div class="category-list__container" v-dragscroll="!isMobile">
                        <CategoryItem
                        title="Toate Categoriile"
                        :active="!$route.params.slug"
                        @click="selectCategory(null)"/>

                        <CategoryItem 
                            v-for="(category, i) in categories" 
                            :key="i"
                            :title="category.name"
                            :active="$route.params.slug == category.slug"
                            @click="selectCategory(category.id)"
                        />
                    </div>
                </div>

                <div class="specialists__list">
                    <SpecialistCard v-if="specialistsLoading || !specialists" :skeleton="true"/>
                    <SpecialistCard v-if="specialistsLoading || !specialists" :skeleton="true"/>
                    <SpecialistCard v-if="specialistsLoading || !specialists" :skeleton="true"/>
                    <SpecialistCard v-if="specialistsLoading || !specialists" :skeleton="true"/>

                    <template v-if="!specialistsLoading && specialists">
                        <SpecialistCard
                            v-for="(specialist, i) in specialists"
                            :key="i"
                            :id="specialist.id"
                            :name="specialist.full_name"
                            :title="specialist.title"
                            :text="specialistDescription(specialist.about)"
                            :imageUrl="specialist.image_url"
                            :rating="specialist.rating"
                            :isActive="specialist.overtime"
                        />
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CategoryItem from './components/CategoryItem'
import SpecialistCard from './components/SpecialistCard'

import { mapActions } from 'vuex'
import { mapGetters } from 'vuex'

import router from '@/router.js'

export default {
    components: {
        CategoryItem,
        SpecialistCard
    },
    mounted() {
        this.fetchCategories();
        this.fetchSpecialists(router.currentRoute.params.slug);
    },
    computed: {
        ...mapGetters({
            specialists: 'specialists/specialists',
            specialistsLoading: 'specialists/specialistsLoading',
            categories: 'specialists/categories',
            selectedCategoryId: 'specialists/selectedCategoryId',
            isMobile: 'layout/isMobile'
        }),
        isCategorySelected: function(slug) {
            if(this.selectedCategory == slug)
                return true;
            return false;
        }
    },
    methods: {
        ...mapActions({
            fetchSpecialists: 'specialists/specialists',
            fetchCategories: 'specialists/categories',
        }),
        specialistDescription(description){
            description = description.replace(/<[^>]*>?/gm, '');
            return description.substring(0, 65) + "...";
        },
        selectCategory(id) {
            // fixed by @pebly
            const index = this.categories.findIndex(
                (item) => item.id === id
            );

            if (index === -1) {
                id = null;
            }

            this.$store.state.specialists.selectedCategoryId = index;

            if (id) {
                var slug = this.categories[this.selectedCategoryId].slug;

                this.fetchSpecialists(slug);
                router.push({
                    path: `/specialists/${slug?slug:''}`
                });
            } else {
                this.fetchSpecialists(null);
                router.push({
                    path: `/specialists`
                });
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    @import '@/scss/pages/specialists';
</style>
